import { AuthFetchWithResult } from '@e3dc-react/shell/Types/api'
import { ChargingCardDto } from './dto/charging-cards-dto'

export const fetchChargingCards = async (installationId: number, authFetch: AuthFetchWithResult): Promise<ChargingCardDto[]> => {
  return authFetch<ChargingCardDto[]>({
    path: `tokens/installation/${installationId}`,
    endpoint: process.env.REACT_APP_HAGER_BRIDGE_SERVICE,
    method: 'GET',
  })
}
